<template>
  <div class="common-layout">
    <el-container class="container">
      <el-container>
        <el-header class="header">
          <NavTop />
        </el-header>
        <!-- 页面主体区域 -->
        <el-container>
          <!-- 侧边栏 -->
          <el-aside :width="isCollapse ? '64px' : '200px'">
            <el-menu
              active-text-color="#3370FF"
              background-color="#FFFFFF"
              text-color="#333333"
              :unique-opened="true"
              :collapse="isCollapse"
              :collapse-transition="true"
              :router="true"
              :default-active="$route.path"
              class="menu-class"
              @select="handleSelect"
            >
              <template v-for="(item, i) in routes">
                <el-menu-item v-if="!item.select" :key="i" :index="item.path">
                  <template #title>
                    <img
                      :src="require(`../assets/img/manage/menu/${iconsObj[item.meta.title]}_${$route.path == item.path ? 'a' : 'd'}.png`)"
                      width="16px"
                      height="16px"
                    >
                    <span @click="titleName(item.meta.title)">{{ item.meta.title }}</span>
                  </template>
                </el-menu-item>
                <el-submenu v-else :key="i" :index="item.path">
                  <template #title>
                    <img
                      :src="require(`../assets/img/manage/menu/${iconsObj[item.meta.title]}_d.png`)"
                      width="16px"
                      height="16px"
                    >
                    <span>{{ item.meta.title }}</span>
                  </template>
                  <el-menu-item
                    v-for="(subItem, index) in item.children"
                    v-show="!subItem.hidden"
                    :key="index"
                    :index="subItem.path"
                  >
                    <span>{{ subItem.meta.title }}</span>
                  </el-menu-item>
                </el-submenu>
              </template>
            </el-menu>
          </el-aside>
          <!-- 右侧内容主体区域 -->
          <el-main>
            <div class="titleName">{{ titleNameString }}</div>
            <!-- 路由占位符 -->
            <router-view />
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
// import AppMenu from '@/components/AppMenu.vue';
import NavTop from './manage/navTop.vue'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    NavTop
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      // 左侧菜单数据对象
      menulist: [
        //  {id:111,authName:'首页',path:'home',children:[],order:1,select: false,},
        {
          id: 110,
          authName: '我的设置',
          // path: 'produce',
          children: [
            {
              id: 111,
              authName: '我的商品',
              path: 'commodities',
              children: [],
              order: null
            },
            {
              id: 112,
              authName: '公司信息',
              path: 'produce',
              children: [],
              order: null
            },
            {
              id: 113,
              authName: '账户信息',
              path: 'produce',
              children: [],
              order: null
            },
            {
              id: 114,
              authName: '地址库信息',
              path: 'produce',
              children: [],
              order: null
            }
          ],
          order: 2,
          select: true
        }
      ],
      // 字体图标对象
      iconsObj: {
		  '批量下单': 'OrderImport',
        '我的订单': 'Shipments',
        '我的账单': 'Billing',
        '我的设置': 'MySettings'
      },
      // 是否折叠
      isCollapse: false,
      fatherTitle: ''
      // titleNameString:'',
    }
  },
  computed: {
    // 计算属性
    routes() {
      let list = this.$router.options.routes || []
	  console.log(list)
      if (list.length > 0) {
        list = list.filter((res) => {
          return res.path == '/manage'
        })
      }
      return list[0].children
    },
    titleNameString() {
      return this.$route.meta.title
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    // this.getMenuList()
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    // 获取所有的菜单数据
    // async  getMenuList () {
    //   const { data: res } = await this.$http.get('menus')
    //   if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
    //   // 成功了，进行赋值
    //   this.menulist = res.data
    //   console.log(res)
    // },
    // 点击按钮，切换菜单的折叠与展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    handleSelect(key, keypath) {
      this.fatherTitle = keypath[0] || ''
      console.log(key, keypath)
    },
    titleName(name) {
      // this.titleNameString = name
    }
  }
}
</script>
<style scoped lang="scss">
	.common-layout {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 999;
		overflow: auto;
		background: #f2f4f8;
	}

	.container {
		height: 100%;

		.titleName {
			height: 80px;
			display: flex;
			justify-content: left;
			align-items: center;
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			font-size: 24px;
			color: #333333;
			text-align: left;
			font-style: normal;
		}

		.aside {
			background: #797979;
			width: 230px;
		}

		::v-deep .el-header {
			padding: 0;
			height: 64px !important;
		}

		.menu-class {
			height: 100%;
			text-align: left;

			img {
				margin: 0 8px;
			}

			::v-deep .el-submenu__title,
			.el-menu-item {
				height: 48px;
				line-height: 40px;
				padding: 4px 8px !important;

				&:active {
					background-color: rgba(51, 112, 255, 0.08) !important;
				}

				// &:hover{
				//       background-color: rgba(237,119,56,0.08) !important;
				// }
				a {
					color: #333333;
					text-decoration: auto;
				}
			}

			::v-deep .is-active {
				background: rgba(51, 112, 255, 0.08) !important;
				color: #3370ff !important;
			}

			::v-deep .el-submenu {
				.el-menu-item {
					padding-left: 39px !important;
				}
			}
		}
	}
</style>
